<template>
  <div class="wrapper">
    <v-parallax class="section page-header header-filter"  :style="headerStyle">
      <div class="container">
        <div class="md-layout">
          <div
            class="md-layout-item md-size-50 md-small-size-70 md-xsmall-size-100"
          >
            <h1 class="title">Your Story Starts With Us.</h1>
            <h4>
              our web application is trying to help players find data and information they need in a game, and 
              we also support different kinds of way to share, communicate, and discover.
              do not be shy in this website, come to talk with people.
              you can find more in......
            </h4>
            <v-btn
              to="/videoplayer"
              >Watch video</v-btn
            >
          </div>
        </div>
      </div>
    </v-parallax>
    <div class="main main-raised">
      <div class="section">
        <div class="container">
          <div class="md-layout">
            <div
              class="md-layout-item md-size-66 md-xsmall-size-100 mx-auto text-center"
            >
              <h2 class="title text-center">Let's talk about......</h2>
              <h5 class="description">
                This is the Page where you can know more details about
                what you can do in this website. If you still have questiones, please contact us with no hesitate.
              </h5>
            </div>
          </div>
<v-layout row justify-space-around wrap>

       <v-card max-width="300px">
        <v-img
          src="https://static.bandainamcoent.eu/high/dark-souls/dark-souls-hd/03-news/dshd_switch-release-date.jpg"
          aspect-ratio="2.75"
        ></v-img>
        <v-card-title primary-title>
          <div>
            <h3 class="headline mb-0">Videos</h3>
            <div> Videos from players like you! and some videos from offical site of game</div>
          </div>
        </v-card-title>

        <v-card-actions>
          <v-btn flat color="blue">Share</v-btn>
          <v-btn flat color="blue" to="/videoplayer">Explore</v-btn>
        </v-card-actions>
      </v-card>

       <v-card max-width="300px">
        <v-img
          src="https://live.staticflickr.com/1911/43761875090_1a06edb485_b.jpg"
          aspect-ratio="2.75"
        ></v-img>
        <v-card-title primary-title>
          <div>
            <h3 class="headline mb-0">Game</h3>
            <div> Videos from players like you! and some videos from offical site of game </div>
          </div>
        </v-card-title>

        <v-card-actions>
          <v-btn flat color="blue">Share</v-btn>
          <v-btn flat color="blue">Explore</v-btn>
        </v-card-actions>
      </v-card>

       <v-card max-width="300px">
        <v-img
          src="https://cdn02.nintendo-europe.com/media/images/10_share_images/games_15/nintendo_switch_4/H2x1_NSwitch_DarkSoulsRemastered_image1600w.jpg"
          aspect-ratio="2.75"
        ></v-img>
        <v-card-title primary-title>
          <div>
            <h3 class="headline mb-0">Discussion</h3>
            <div> Videos from players like you! and some videos from offical site of game </div>
          </div>
        </v-card-title>

        <v-card-actions>
          <v-btn flat color="blue">Share</v-btn>
          <v-btn flat color="blue" to="/Discussion">Explore</v-btn>
        </v-card-actions>
      </v-card>

</v-layout> 
        </div>
      </div>
      <div class="section text-center">
        <div class="container">
          <h2 class="title">Here is our suppliers</h2>
          <div class="team">
            <div class="md-layout">
              <div class="md-layout-item md-medium-size-33 md-small-size-100">
                <div class="team-player">
                  <md-card class="md-card-plain">
                    <div class="md-layout-item md-size-50 mx-auto">
                      <img
                        :src="teamImg1"
                        alt="Thumbnail Image"
                        class="img-raised rounded-circle img-fluid"
                      />
                    </div>
                    <h4 class="card-title">
                      IGN global
                      <br />
                      <small class="card-description text-muted">News</small>
                    </h4>

                    <md-card-content>
                      <p class="card-description">
                        Ign provides news for this web application which can be reliable and real-time
                        <a href="https://uk.ign.com/">Offical site IGN</a> for everyone
                        to be able to follow them outside the site.
                      </p>
                    </md-card-content>

                    <md-card-actions class="text-center">
                      <md-button
                        href="javascript:void(0)"
                        class="md-just-icon md-simple"
                      >
                        <i class="fab fa-twitter"></i>
                      </md-button>
                      <md-button
                        href="javascript:void(0)"
                        class="md-just-icon md-simple"
                      >
                        <i class="fab fa-instagram"></i>
                      </md-button>
                      <md-button
                        href="javascript:void(0)"
                        class="md-just-icon md-simple"
                      >
                        <i class="fab fa-facebook-square"></i>
                      </md-button>
                    </md-card-actions>
                  </md-card>
                </div>
              </div>
              <div class="md-layout-item md-medium-size-33 md-small-size-100">
                <div class="team-player">
                  <md-card class="md-card-plain">
                    <div class="md-layout-item md-size-50 mx-auto">
                      <img
                        :src="teamImg2"
                        alt="Thumbnail Image"
                        class="img-raised rounded-circle img-fluid"
                      />
                    </div>
                    <h4 class="card-title">
                      Electronic Art
                      <br />
                      <small class="card-description text-muted"
                        >TecSupport</small
                      >
                    </h4>

                    <md-card-content>
                      <p class="card-description">
                        TecSupport, who supports some professional comments and technology information
                        <a href="https://www.ea.com/zh-cn">Offical site EA</a> for everyone
                        to be able to follow them outside the site.
                      </p>
                    </md-card-content>

                    <md-card-actions class="text-center">
                      <md-button
                        href="javascript:void(0)"
                        class="md-just-icon md-simple"
                      >
                        <i class="fab fa-twitter"></i>
                      </md-button>
                      <md-button
                        href="javascript:void(0)"
                        class="md-just-icon md-simple"
                      >
                        <i class="fab fa-linkedin"></i>
                      </md-button>
                    </md-card-actions>
                  </md-card>
                </div>
              </div>
              <div class="md-layout-item md-medium-size-33 md-small-size-100">
                <div class="team-player">
                  <md-card class="md-card-plain">
                    <div class="md-layout-item md-size-50 mx-auto">
                      <img
                        :src="teamImg3"
                        alt="Thumbnail Image"
                        class="img-raised rounded-circle img-fluid"
                      />
                    </div>
                    <h4 class="card-title">
                      UBisoft
                      <br />
                      <small class="card-description text-muted">Store</small>
                    </h4>

                    <md-card-content>
                      <p class="card-description">
                        Buy Ubsoft's game in a cheaper price, and can be used in offical platform like Uplay
                        <a href="#">Offical site </a> for people
                        to be able to follow them outside the site.
                      </p>
                    </md-card-content>

                    <md-card-actions class="text-center">
                      <md-button
                        href="javascript:void(0)"
                        class="md-just-icon md-simple"
                      >
                        <i class="fab fa-twitter"></i>
                      </md-button>
                      <md-button
                        href="javascript:void(0)"
                        class="md-just-icon md-simple"
                      >
                        <i class="fab fa-instagram"></i>
                      </md-button>
                      <md-button
                        href="javascript:void(0)"
                        class="md-just-icon md-simple"
                      >
                        <i class="fab fa-facebook-square"></i>
                      </md-button>
                    </md-card-actions>
                  </md-card>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="section section-contacts">
        <div class="container">
          <div class="md-layout">
            <div class="md-layout-item md-size-66 md-xsmall-size-100 mx-auto">
              <h2 class="text-center title">Contact us</h2>
              <h4 class="text-center description">
               Still have questiones and problems? you can use this link to tell us how can we help you. sorry about any problems we caused to you.
              </h4>
              <form class="contact-form">
                <div class="md-layout">
                  <div class="md-layout-item md-size-50">
                    <md-field>
                      <label>Your Name</label>
                      <md-input v-model="name" type="text"></md-input>
                    </md-field>
                  </div>
                  <div class="md-layout-item md-size-50">
                    <md-field>
                      <label>Your Email</label>
                      <md-input v-model="email" type="email"></md-input>
                    </md-field>
                  </div>
                </div>

                  <label>Your Message</label>
                  <v-textarea box v-model="message"></v-textarea>
        
                <div class="md-layout">
                  <div class="md-layout-item md-size-33 mx-auto text-center">
                    <md-button class="md-success">Send Message</md-button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  
</template>

<script>
import Vue from 'vue'
import MaterialKit from '../plugins/material-kit'
import VueMaterial from "vue-material";
Vue.use(VueMaterial);
export default {
  bodyClass: "landing-page",
  props: {
    header: {
      type: String,
      default: require("@/assets/bg7.jpg")
    },
    teamImg1: {
      type: String,
      default: require("@/assets/faces/ign.webp")
    },
    teamImg2: {
      type: String,
      default: require("@/assets/faces/ea.webp")
    },
    teamImg3: {
      type: String,
      default: require("@/assets/faces/ubsoft.webp")
    }
  },
  data() {
    return {
      name: null,
      email: null,
      message: null
    };
  },
  computed: {
    headerStyle() {
      return {
        backgroundImage: `url(${this.header})`
      };
    }
  }
};
</script>

<style lang="scss" scoped>
@import "vue-material.css";
@import "@/assets/scss/material-kit.scss";
.contact-form {
  margin-top: 30px;
}
</style>
